export default "__VITE_ASSET__C7l7vPtf__"